import { u, styled } from '../../../../shared/theming-sc'

const RowActionWrapper = styled.span`
    float: right;
`

const RowActionButton = styled.a`
    display: inline-block;
    border-radius: 100px;
    border: 1px solid ${u.getColor('greyDark')};
    color: ${u.getColor('greyDark')};
    font-size: ${u.getFontSize('md')};
    font-weight: 500;
    padding: 2px ${u.getSpacing('small')}px;
    margin-top: -8px;
    margin-left: 10px;
    margin-right: 10px;
`

const RowActionLink = styled.a`
    display: inline-block;
    font-weight: bold;
    font-size: 15px;
    text-decoration: underline;
    color: #4d4d4d;

`

export {
  RowActionWrapper,
  RowActionButton,
  RowActionLink
}
